module.exports = __webpack_public_path__ + "static/media/mitch-suit.e61be363.png";